import React from 'react';

import { CommonProvider } from './store/CommonContext';
import { TemplateProvider } from './store/TemplateContext';
import { PaymentProvider } from './store/PaymentContext';
import { LinksProvider } from './store/LinksContext';

import MainRoutes from './routs/MainRoutes';
import ErrorBoundary from './helpers/ErrorBoundary';

import './App.css';
import './styles/general.css';
import './styles/layout.css';
import './styles/form.css';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function App() {
  return (
    <ErrorBoundary>
      <CommonProvider>
        <TemplateProvider>
          <PaymentProvider>
            <LinksProvider>
              <MainRoutes />
            </LinksProvider>
          </PaymentProvider>
        </TemplateProvider>
      </CommonProvider>
    </ErrorBoundary>
  );
}

export default App;
